import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Button, MenuItem, TextField } from "@mui/material";
import moment from "jalali-moment";
import { managementService } from "../../../../api/services/management";
import { recordsService, rowsOf } from "../../../../api/services/records";
import useRemote, { refreshRecords } from "../../../../hooks/useRemote";
import useMutation from "../../../../hooks/useMutation";
import { MigrationPage, Outcome } from "../../../shares/migration/MigrationWidgets";

function ImportForm({ kind, groups }) {
  const mutation = useMutation();
  const [validation, setValidation] = useState("");
  const [file, setFile] = useState(null);
  const submit = async (event) => {
    event.preventDefault(); setValidation("");
    const data = new FormData(event.currentTarget);
    const date = String(data.get("date")).replace(/[۰-۹]/g, (digit) => "۰۱۲۳۴۵۶۷۸۹".indexOf(digit));
    if (!/^\d{4}\/\d{2}\/\d{2}$/.test(date) || !moment(date, "jYYYY/jMM/jDD", true).isValid()) {
      setValidation("تاریخ شمسی را مانند 1403/07/15 وارد کنید."); return;
    }
    if (!file) { setValidation("فایل اکسل را انتخاب کنید."); return; }
    data.set("date", date); data.set("file", file);
    const result = await mutation.run((signal) => recordsService.import(kind, data, signal));
    if (result) refreshRecords();
  };
  return <section className="rounded-panel border border-rule bg-surface p-xl space-y-6">
    <h2>{kind === "exam" ? "آزمون حضوری" : "حضور و غیاب جلسه"}</h2>
    <p>ستون‌های اکسل: «کد ملی» {kind === "exam" ? "و «درصد»؛ «حاضر» اختیاری است." : "؛ «وضعیت» (حاضر/غایب) اختیاری است."}</p>
    {kind === "exam" && <Alert severity="warning">ورود دوباره همان نام آزمون و گروه، نتایج قبلی را بازنویسی می‌کند.</Alert>}
    <form className="flex flex-wrap gap-4" onSubmit={submit}>
      <TextField required name={kind === "exam" ? "exam_name" : "session_title"} label={kind === "exam" ? "نام آزمون" : "عنوان جلسه"} />
      <TextField required select name="group" label="گروه" defaultValue="" className="min-w-[16rem]">
        {groups.map((group) => <MenuItem key={group.id} value={group.name}>{group.name}</MenuItem>)}
      </TextField>
      <TextField required name="date" label="تاریخ شمسی" placeholder="1403/07/15" inputProps={{ dir: "ltr" }} />
      {kind === "exam" && <TextField name="headline" label="مبحث (اختیاری)" />}
      <label className="block">فایل اکسل<input type="file" accept=".xlsx,.xls" required onChange={(event) => setFile(event.target.files[0] || null)} /></label>
      <Button disabled={mutation.disabled || !groups.length} type="submit" variant="contained">بارگذاری</Button>
    </form>
    {(validation || mutation.error) && <Alert severity="error">{validation || mutation.error}</Alert>}
    {mutation.cooldown > 0 && <p>لطفاً پیش از درخواست بعدی کمی صبر کنید.</p>}
    <Outcome data={mutation.result} />
    {kind === "exam" && mutation.result?.exam_id && <Link className="block text-primary"
      to={"/admin/offline-exams?exam=" + encodeURIComponent(mutation.result.exam_id)}>مشاهده نتایج این آزمون</Link>}
  </section>;
}
export default function Imports() {
  const groups = useRemote((signal) => managementService.allGroups(signal));
  return <MigrationPage title="ورود اطلاعات از اکسل">
    {groups.error && <Alert severity="error">{groups.error.message}</Alert>}
    <ImportForm kind="exam" groups={rowsOf(groups.data)} />
    <ImportForm kind="attendance" groups={rowsOf(groups.data)} />
  </MigrationPage>;
}
